import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { ButtonDirective } from '@openng/optimus-ui/button';

@Component({
  selector: 'app-contact-list-mobile-filter',
  templateUrl: './contact-list-mobile-filter.component.html',
  styleUrls: ['./contact-list-mobile-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateDirective,
    FormsModule,
    InputText,
    ButtonDirective,
    TranslatePipe,
  ],
})
export class ContactListMobileFilterComponent {
  readonly showMobileFilter = input<boolean>();
  readonly mobileFilterEvent = output<any>();

  state!: string | null;
  county!: string | null;
  township!: string | null;

  mobileFilter() {
    this.mobileFilterEvent.emit({
      state: this.state,
      county: this.county,
      township: this.township,
    });
  }

  clear() {
    this.state = null;
    this.county = null;
    this.township = null;
    this.mobileFilter();
  }
}
